export const checkAbilities = (userAbilities: any, allowedAbilities: any) => {
  if (allowedAbilities.length === 0) return true;

  return userAbilities.some((ability: string) => allowedAbilities.includes(ability));
};
